import { useCustom } from './useCustom';
import { ToastMessage } from '@skf/bt-wind-rail-commonlibrary/dist/components/common/toastCluster/ToastCluster';

export const useToast = () => {
  const [state, setState] = useCustom();

  const lastToast = state._lastToast;

  const addToast = (toastMessage: ToastMessage) => {
    toastMessage.datetime = Date.now();
    process.nextTick(() => {
      setState({ _lastToast: toastMessage });
    });
  };

  return { addToast, lastToast };
};